import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import IntegrationID from '@/App/Integration/Entity/IntegrationID'
import {
    IntegrationProviderEnum,
    IntegrationStateEnum,
    type GoogleCalendarSettingsData,
    type IntegrationData,
    type OutlookCalendarSettingsData,
} from '@/Shared/AutoGenerated/Main'

export default class Integration {
    constructor(
        public readonly id: IntegrationID,
        public readonly name: string,
        public readonly state: IntegrationStateEnum,
        public readonly provider: IntegrationProviderEnum,
        public readonly externalId: string | null,
        public readonly metadata: object,
    ) {
        ensureNoUndefinedProperties(this)
    }

    canContinueSetup() {
        return this.state === IntegrationStateEnum.Inactive
    }

    getGoogleCalendarIntegrationSettings(): GoogleCalendarSettingsData {
        if (this.provider !== IntegrationProviderEnum.GoogleCalendar) {
            throw new Error('Invalid provider')
        }

        return this.metadata as GoogleCalendarSettingsData
    }

    getOutlookCalendarIntegrationSettings(): OutlookCalendarSettingsData {
        if (this.provider !== IntegrationProviderEnum.OutlookCalendar) {
            throw new Error('Invalid provider')
        }

        return this.metadata as OutlookCalendarSettingsData
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingleOrNull(
        entityData: IntegrationData,
    ): Integration | null {
        if (!entityData) {
            return null
        }

        return Integration.hydrateSingle(entityData)
    }

    static hydrateSingle(entityData: IntegrationData): Integration {
        return new Integration(
            new IntegrationID(entityData.id),
            entityData.name,
            entityData.state,
            entityData.provider,
            entityData.externalId,
            entityData.metadata,
        )
    }

    static hydrateMultiple(entitiesData: IntegrationData[]): Integration[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
